import React, { useState } from 'react';
import { Container, Fade, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const propTypes = {
  title: PropTypes.string,
  links: PropTypes.arrayOf(Object),
};
const defaultProps = {
  title: '',
  links: [],
};

export default function SubNavigation({ links, title }) {
  const [fadeIn, setFadeIn] = useState(false);
  setTimeout(() => setFadeIn(true), 100);

  return (
    <Fade in={fadeIn}>
      <Navbar
        bg="light"
        expand="lg"
        className="border-bottom shadow-sm mb-3 m-0 mt-sm-3 mb-sm-4"
      >
        <Container fluid>
          <Navbar.Brand data-testid="Text-title">{title}</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {links.map((link, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Nav.Link
                  as={Link}
                  key={`link-${index.toString()}`}
                  to={link.path}
                  data-testid="Link-page"
                >
                  {link.title}
                </Nav.Link>
                // <Nav.Link as={Link} to="#" onClick={onLogout}>Logout</Nav.Link>
              ))}
              {links.length === 0 && <Nav.Link to="#">&nbsp;</Nav.Link>}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Fade>
  );
}

SubNavigation.propTypes = propTypes;
SubNavigation.defaultProps = defaultProps;
